import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-GeoMapPreview';

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  borderRadius: 'inherit',
}));

interface Props {
  isMainMap: boolean;
}

export const GeoMapPreview = ({ isMainMap = true }: Props) => (
  <Root>
    <img
      style={{ borderRadius: 'inherit', pointerEvents: 'none' }}
      src={isMainMap ? '/geo-map.png' : '/focus-view.png'}
      alt={isMainMap ? 'Geo Map' : 'Focus View'}
      width={195}
      height={145}
    />
  </Root>
);
